export const BLIK_FIRST_PAYMENT_METHOD_ORDER = ['blik', 'card'];

export const STRIPE_PAYMENT_ELEMENT_OPTIONS = {
	layout: {
		type: 'tabs',
		defaultCollapsed: false,
		radios: 'never',
		spacedAccordionItems: false,
	},
	paymentMethodOrder: ['card', 'klarna', 'paypal'],
	fields: {
		billingDetails: {
			address: {
				country: 'never',
			},
		},
	},
	wallets: {
		link: 'auto',
		applePay: 'auto',
		googlePay: 'auto',
	},
	terms: {
		card: 'never',
	},
};
